/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
// @ts-expect-error cademy-shared-web is untyped
import { request } from 'cademy-shared-web';
import { Environment } from 'services/Environment';

declare global {
    var posthog: any;
}

request.setLoginRedirectURL(`${Environment.MARKETPLACE_URL}/login`);
request.setBaseUrl(Environment.API_URL);

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
